import React from 'react';

import { MerchantOverview } from '../molecules';
import { useAccount } from '../useMerchantSettings';

export function Account() {
  const { merchant } = useAccount();

  return (
    <MerchantOverview
      {...{
        merchant,
      }}
    />
  );
}
